export default __webpack_public_path__ + "static/media/juego5_instrucciones.8863b26a.png";